import React, { ReactNode } from "react";
import styled from "styled-components";

export interface V3PageContainerProps {
  children: ReactNode;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  testID?: string;
}

/** Matches the home screen: centred column, same page fill edge to edge. */
const Outer = styled.div`
  display: flex;
  justify-content: center;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.ui.background.page};
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1366px;
  padding: 60px 120px 80px;

  @media (max-width: 1100px) {
    padding: 32px 40px 64px;
  }
`;

export const V3PageContainer = ({
  children,
  as = "div",
  className,
  testID = "v3-page-container",
}: V3PageContainerProps): JSX.Element => (
  <Outer className={className} data-testid={testID}>
    <Column as={as}>{children}</Column>
  </Outer>
);
